import React from "react";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import * as Icons from "lucide-react";
import { services, turnaround } from "../data/mock";

const Services = () => {
  return (
    <section id="services" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <Badge className="bg-green-50 text-green-700 border border-green-200 hover:bg-green-50 mb-4">Our Services</Badge>
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tight">Every vehicle. Every year. One shop.</h2>
          <p className="text-slate-600 mt-4 text-lg">
            From modern hybrids to 1970s classics and heavy-duty diesel trucks — Hamilton's is the only STAR-certified smog station in Novato equipped to handle it all.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((s) => {
            const Icon = Icons[s.icon] || Icons.Car;
            return (
              <Card key={s.title} className="card-hover border-slate-200 border rounded-xl overflow-hidden group">
                <CardContent className="p-7">
                  <div className="flex items-start justify-between mb-4">
                    <div className="w-12 h-12 rounded-lg bg-slate-900 text-white grid place-items-center group-hover:bg-green-600 transition-colors">
                      <Icon className="w-6 h-6" />
                    </div>
                    <span className="text-xs font-bold text-slate-500 bg-slate-100 rounded-full px-3 py-1">{s.time}</span>
                  </div>
                  <h3 className="text-lg font-black text-slate-900 mb-2">{s.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{s.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Turnaround times */}
        <div className="mt-14 bg-slate-950 rounded-2xl p-8 md:p-10 text-white">
          <div className="grid md:grid-cols-4 gap-8 items-center">
            <div className="md:col-span-1">
              <Badge className="bg-green-600 hover:bg-green-600 text-white border-0 mb-3">Turnaround</Badge>
              <h3 className="text-2xl md:text-3xl font-black leading-tight">In &amp; out fast — every time.</h3>
              <p className="text-slate-400 mt-2 text-sm">Two service bays. Two certified techs. Zero wasted time.</p>
            </div>
            <div className="md:col-span-3 grid sm:grid-cols-3 gap-4">
              {turnaround.map((t) => (
                <div key={t.year} className="bg-white/5 border border-white/10 rounded-xl p-5 hover:border-green-500 transition-colors">
                  <div className="text-green-400 font-bold text-sm uppercase tracking-wider">{t.year}</div>
                  <div className="text-2xl md:text-3xl font-black mt-2">{t.time}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
